// Modules
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

// Constants
import { FILE_TYPE } from '@accidents/shared/constants/index';

@Component({
    selector: 'sbi-cot-back-images-data-modal',
    templateUrl: './images-data-modal.component.html',
    styleUrls: ['./images-data-modal.component.scss'],
    standalone: false
})
export class ImagesDataModalComponent implements OnInit {
  public statusClassname: string = null;
  public fileType = FILE_TYPE;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this._setStatusClassName();
  }

  // Private method to set the statusClass name
  private _setStatusClassName(): void {
    this.statusClassname = this.data.image.status
      .toLowerCase()
      .replace(/\s/g, '');
  }
}
